import { render } from "./CategorySelector.vue?vue&type=template&id=3b1c77f2"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/CategorySelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b1c77f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b1c77f2', __exports__)) {
    api.reload('3b1c77f2', __exports__)
  }
  
  module.hot.accept("./CategorySelector.vue?vue&type=template&id=3b1c77f2", () => {
    api.rerender('3b1c77f2', render)
  })

}


export default __exports__